import { render } from "./index.vue?vue&type=template&id=58c8fb2b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=58c8fb2b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c8fb2b"],['__file',"src/views/ResetPwd/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58c8fb2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58c8fb2b', __exports__)) {
    api.reload('58c8fb2b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=58c8fb2b&scoped=true", () => {
    api.rerender('58c8fb2b', render)
  })

}


export default __exports__